export function resolveWallRewardClearSpeed(
  bestClearMs: number,
  targetClearMs: number,
  softcapClearMs: number,
): number {
  if (bestClearMs >= softcapClearMs) return targetClearMs / bestClearMs;
  return (
    (targetClearMs / softcapClearMs) *
    (1 + Math.log(softcapClearMs / bestClearMs))
  );
}
